import { Value } from 'firebase/remote-config';

import {
  ActionTypes,
  CallInNumberAction,
  CardTypeAction,
  ClearDiscountOptionsAction,
  CommercialCCFeeAction,
  CommercialFeeConsentAction,
  CookiePassAction,
  SetCurrentlyInNGCAction,
  Copper2FiberAction,
  CountdownExpiration,
  DiscountOptions,
  ExpirationBannerAction,
  FirebaseAction,
  HideDebugAction,
  HideFrontierLogoAction,
  InstallationOptions,
  MonarchDecisionAction,
  MonarchDecisionPayload,
  PageLoadingAction,
  PreampAction,
  RemoveAcpAction,
  RemoveExpirationBannerAction,
  RemoveQuoteAction,
  ResetSingleFormAction,
  ResetStateAction,
  ResumeAction,
  SessionExpiredAction,
  SetBuyflowRedirectDelayAction,
  SetcanNavigateToBuyFlowRedirectAction,
  SetCustomOffersAction,
  SetDiscountOptionsAction,
  SetInstallationOptionsAction,
  SetIspAction,
  SetUtmParamsAction,
  SingleFormAction,
  TrackingAction,
  SetOfferMerchDataAction,
} from '~/types/common';
import { OfferMerchMetadata } from '~/types/offerObject';

export const setTracking = (key: string, id: string): TrackingAction => {
  return { type: ActionTypes.SET_TRACKING, key, id };
};

export const setPageLoading = (loading: boolean): PageLoadingAction => {
  return { type: ActionTypes.SET_PAGE_LOADING, loading };
};

export const setCallInNumber = (callInNumber: string): CallInNumberAction => {
  return { type: ActionTypes.SET_CALL_IN_NUMBNER, callInNumber };
};

export const removeACP = (): RemoveAcpAction => {
  return { type: ActionTypes.REMOVE_ACP };
};

export const removeQuote = (): RemoveQuoteAction => {
  return { type: ActionTypes.REMOVE_QUOTE };
};

export const removeExpirationBanner = (): RemoveExpirationBannerAction => {
  return { type: ActionTypes.REMOVE_EXPIRATION_BANNER };
};

export const setMonarchDecision = (payload: MonarchDecisionPayload): MonarchDecisionAction => {
  return { type: ActionTypes.SET_MONARCH_DECISION, payload };
};

export const setPreamp = (key: string, value: Record<string, unknown> | string | number | boolean): PreampAction => {
  return { type: ActionTypes.SET_PREAMP_ACTION, key, value };
};

export const setCountdownExpiration = (countdownExpiration: string): CountdownExpiration => {
  return { type: ActionTypes.COUNTDOWN_EXPIRATION, countdownExpiration };
};

export const setC2F = (key: string, value: boolean | string): Copper2FiberAction => {
  return { type: ActionTypes.SET_C2F, key, value };
};

export const setResume = (key: string, value: boolean | string): ResumeAction => {
  return { type: ActionTypes.SET_RESUME, key, value };
};

export const setSingleForm = (key: string, value: boolean | string | number): SingleFormAction => {
  return { type: ActionTypes.SET_SINGLE_FORM, key, value };
};

export const resetSingleForm = (): ResetSingleFormAction => {
  return { type: ActionTypes.RESET_SINGLE_FORM };
};

export const setCommercialFeeConsent = (commercialFeeConsent: boolean): CommercialFeeConsentAction => {
  return { type: ActionTypes.SET_FEE_CONSENT, commercialFeeConsent };
};

export const setCommercialCCFee = (commercialCreditCardfee: number): CommercialCCFeeAction => {
  return { type: ActionTypes.SET_COMMERCIAL_CC_FEE, commercialCreditCardfee };
};

export const setCardType = (cardType: string): CardTypeAction => {
  return { type: ActionTypes.SET_CARD_TYPE, cardType };
};

export const setCookiePass = (cookiePass: boolean): CookiePassAction => {
  return { type: ActionTypes.SET_COOKIE_PASS, cookiePass };
};

export const setSessionExpired = (expired: boolean): SessionExpiredAction => {
  return { type: ActionTypes.SET_SESSION_EXPIRED, expired };
};

export const setHideFrontierLogo = (hide: boolean): HideFrontierLogoAction => {
  return { type: ActionTypes.SET_HIDE_FRONTIER_LOGO, hide };
};

export const resetState = (): ResetStateAction => {
  return { type: ActionTypes.RESET_STATE };
};

export const setExpirationBanner = (key: string, value: boolean | string): ExpirationBannerAction => {
  return { type: ActionTypes.SET_EXPIRATION_BANNER, key, value };
};

export const setHideDebug = (value: boolean): HideDebugAction => {
  return { type: ActionTypes.SET_HIDE_DEBUG, value };
};

export const setInstallationOptions = (
  key: string,
  value: InstallationOptions | string | boolean
): SetInstallationOptionsAction => {
  return { type: ActionTypes.SET_INSTALLATION_OPTIONS, key, value };
};

export const setDiscountOptions = (value: DiscountOptions[]): SetDiscountOptionsAction => {
  return { type: ActionTypes.SET_DISCOUNT_OPTIONS, value };
};

export const clearDiscountOptions = (): ClearDiscountOptionsAction => {
  return { type: ActionTypes.CLEAR_DISCOUNT_OPTIONS };
};

export const setCustomOffers = (key: string, value: string | number | boolean): SetCustomOffersAction => {
  return { type: ActionTypes.SET_CUSTOM_OFFERS, key, value };
};

export const setBuyflowRedirectDelay = (value: number): SetBuyflowRedirectDelayAction => {
  return { type: ActionTypes.SET_BUYFLOW_REDIRECT_DELAY, value };
};

export const setUtmParams = (params: SetUtmParamsAction['params']): SetUtmParamsAction => ({
  type: ActionTypes.SET_UTM_PARAMS,
  params,
});

export const setIsp = (isp: string): SetIspAction => ({
  type: ActionTypes.SET_ISP,
  isp,
});

export const setFirebase = (payload: Record<string, Value>): FirebaseAction => {
  return { type: ActionTypes.SET_FIREBASE, payload };
};

export const setcanNavigateToBuyFlowRedirect = (
  canNavigateToBuyFlowRedirect: boolean
): SetcanNavigateToBuyFlowRedirectAction => {
  return { type: ActionTypes.SET_CAN_NAVIGATE_TO_BUY_FLOW_REDIRECT, canNavigateToBuyFlowRedirect };
};

export const setCurrentlyInNGC = (value: boolean): SetCurrentlyInNGCAction => {
  return { type: ActionTypes.SET_CURRENTLY_IN_NGC, value };
};

export const setOfferMerchData = (data: OfferMerchMetadata | null): SetOfferMerchDataAction => {
  return { type: ActionTypes.SET_OFFER_MERCH_DATA, data };
};
